import { formatISO9075 } from "date-fns";
import { Link } from "react-router-dom";

export default function Post({
  _id,
  title,
  content,
  dateCreated,
  image,
  username,
}) {
  return (
    <div className="post">
      <div className="image">
        <Link to={`/post/${_id}`}>
          <img src={image} alt="" />
        </Link>
      </div>
      <div className="texts">
        <Link to={`/post/${_id}`}>
          <h2>{title}</h2>
        </Link>

        <p className="info" style={{ display: "inline" }}>
          {username} <time>{formatISO9075(new Date(dateCreated))}</time>
        </p>
        <Link to={`/post/${_id}`}>
          <div
            className="content"
            dangerouslySetInnerHTML={{ __html: content }}
          />
        </Link>
      </div>
    </div>
  );
}
